/* ATK core — shared reveal engine for atk-* sections.
   Idempotent: the same script tag may be emitted by several sections;
   the guard makes re-execution a no-op. */
(function () {
  "use strict";
  if (window.__atkCore) return;

  var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var io = null;

  function observer() {
    if (io || reduced || !("IntersectionObserver" in window)) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    return io;
  }

  function revealScan(root) {
    var scope = root || document;
    var els = scope.querySelectorAll(".atk-scope .rv:not(.in)");
    if (reduced || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("in"); });
      return;
    }
    var obs = observer();
    els.forEach(function (el, i) {
      el.style.transitionDelay = Math.min((i % 6) * 60, 300) + "ms";
      obs.observe(el);
    });
  }

  window.__atkCore = { revealScan: revealScan, reduced: reduced };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { revealScan(); });
  } else {
    revealScan();
  }
  /* Theme Editor re-renders sections in place */
  document.addEventListener("shopify:section:load", function (e) { revealScan(e.target); });
})();
